<ng-container>
  <div class="nt-header">
    <mydocma-custom-mat-icon
      class="notification-icon"
      [ngClass]="data.iconClass"
      [iconName]="data.iconName"
    ></mydocma-custom-mat-icon>
    <div class="nt-title">
      <span>
          {{ title }}
        </span>
    </div>
    <div class="nt-close-btn">
      <mat-icon (click)="close()">close</mat-icon>
    </div>
  </div>
  <div class="nt-body">
    <div class="nt-content">
      <span>
        {{ content }}
      </span>
    </div>
    <div class="nt-button">
      <button mat-stroked-button cdkFocusInitial class="mydocma-btn-primary" style="width: fit-content; display: flex; align-items: center; max-height: 28px;"
              (click)="callAction()">
        {{ data.buttonText }}
      </button>
    </div>
  </div>
</ng-container>
